module.exports = __webpack_public_path__ + "static/img/portfolio_bg3.0f1f960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_bg-portfolio/portfolio_bg3.png
// module id = Xra2
// module chunks = 1